import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import AnimatedBg from './AnimatedBg';
import BackButtonSkeleton from './BackButtonSkeleton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HighlightHeaderSkeleton = () => {
  return /*#__PURE__*/_jsx(View, {
    paddingBlockStart: "250",
    paddingBlockEnd: "250",
    children: /*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      marginBlock: "25",
      children: [/*#__PURE__*/_jsx(BackButtonSkeleton, {}), /*#__PURE__*/_jsx(View, {
        inlineSize: "80px",
        blockSize: "18px",
        borderRadius: "100",
        overflow: "hidden",
        children: /*#__PURE__*/_jsx(AnimatedBg, {})
      })]
    })
  });
};
export default HighlightHeaderSkeleton;